import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.setActiveTab(this.tabTargets[0])
    this.tabTargets.forEach((tab) => {
      tab.addEventListener("click", () => this.setActiveTab(tab))
    })
  }

  setActiveTab(selectedTab) {
    this.tabTargets.forEach((tab) => {
      if (tab === selectedTab) {
        tab.classList.add("active")
        document.querySelector(tab.dataset.tabsContent).classList.remove("hidden")
      } else {
        tab.classList.remove("active")
        document.querySelector(tab.dataset.tabsContent).classList.add("hidden")
      }
    })
  }
}
